import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import PropTypes from 'prop-types';
import SuggestionBubbles from './SuggestionBubbles';
import chevronIcon from '../assets/chevron_icon.svg';
import './Chat.css';

const promptSuggestions = [
  "What kind of questions can I ask you?",
  "What is my average horsepower usage per job?",
  "What data do you have access to?",
  "What was my average treating pressure in April?",
  "What is my highest treating pressure?",
  "Are there any errors in my data?"
];

const ChatInput = ({
  mode = 'chat',
  onSubmit,
  value,
  onChange,
  onSuggestionClick,
  disabled = false,
  showSuggestions = true,
  disabledPlaceholder = "Question limit reached. Please contact customer service.",
}) => {
  const navigate = useNavigate();
  const { loginWithRedirect } = useAuth0();

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    if (onChange) {
      onChange(newValue);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault(); // Prevent default to avoid new line
      handleSubmit(e);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!value.trim() || disabled) return;

    onSubmit(value);
  };

  const handleSuggestionClick = (suggestion) => {
    if (disabled) return;
    if (onChange) {
      onChange(suggestion);
    }
    // Call the parent's onSuggestionClick if provided
    if (onSuggestionClick) {
      onSuggestionClick(suggestion);
    }
  };

  return (
    <div className="chatinput-main">
      <div className="chat-form">
        <form onSubmit={handleSubmit}>
          <textarea
            value={value || ''}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            placeholder={disabled ? disabledPlaceholder : "Ask me anything about frac data and analysis"}
            className={`chat-input ${disabled ? 'disabled' : ''}`}
            rows={2}
            disabled={disabled}
          />
          <button 
            type="submit" 
            className={`send-button ${disabled ? 'disabled' : ''}`}
            onClick={mode === 'home' ? () => loginWithRedirect() : undefined}
            disabled={disabled}
          >
            <img src={chevronIcon} alt="Send" className="send-icon" />
          </button>
        </form>
      </div>
      {!disabled && showSuggestions && (
        <div>
          <SuggestionBubbles 
            suggestions={promptSuggestions}
            onSuggestionClick={handleSuggestionClick}
          />
        </div>
      )}
    </div>
  );
};

ChatInput.propTypes = {
  mode: PropTypes.oneOf(['home', 'chat']),
  onSubmit: PropTypes.func.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSuggestionClick: PropTypes.func,
  disabled: PropTypes.bool,
  showSuggestions: PropTypes.bool,
  disabledPlaceholder: PropTypes.string
};

export default ChatInput; 